import { useContext } from "react";

import { useHistory } from "react-router-dom";

import RelatedReportsSection from "@/components/reports/RelatedReportsSection";
import { AvailableBadge, Badge, ComingSoonBadge, UnlockBadge } from "@/components/reports/Badges";
import { useOrganisationContext } from "@/contexts/organisations/OrganisationContext";
import { COMING_SOON } from "@/core/constants";
import { CMP_PATIENTS_REPORT_TAB_URL, getCmpUrl } from "@/core/urls";
import useUserProfile from "@/hooks/useUserProfile";
import { ViewerContext } from "@/tpo/Viewer";

import {
  PATIENT_ENTITLEMENTS_QUERY,
  REPORTS_LIST_QUERY
} from "../reports/graphql/queries";

const DESCRIPTION =
  "This test has biomarkers that are featured within the below reports. These reports are available to purchase for your patient and give a holistic view of their bodies function. Uniquely combining DNA & functional markers.";

function getReportCardState({ report, userReports, userEntitlements }) {
  const isComingSoon = report?.purchaseProduct?.status === COMING_SOON;
  const grantedEntitlements = report.purchaseProduct?.grantedEntitlements?.map(
    entitlement => entitlement.key
  );
  const isLocked = !userEntitlements?.some(
    entitlement => grantedEntitlements?.includes(entitlement.key) && entitlement.granted
  );
  const hasUserReport = userReports?.includes(report.id);

  let topRightButton = null;
  if (isComingSoon) {
    topRightButton = <ComingSoonBadge />;
  } else if (isLocked) {
    topRightButton = <UnlockBadge />;
  } else if (!hasUserReport) {
    topRightButton = <Badge>Awaiting Results</Badge>;
  } else {
    topRightButton = <AvailableBadge />;
  }

  return {
    isComingSoon,
    isClickable: !isComingSoon && (isLocked || hasUserReport),
    topRightButton
  };
}

export default function PatientRelatedReportsSection({ userTest }) {
  const history = useHistory();
  const { organisation } = useOrganisationContext();
  const { userId } = useContext(ViewerContext);
  const { practitionerProfile, loading } = useUserProfile();

  if (practitionerProfile && (loading || practitionerProfile.showReportsTab === false)) {
    return null;
  }

  return (
    <RelatedReportsSection
      userTest={userTest}
      reportsQuery={REPORTS_LIST_QUERY}
      reportsQueryVariables={{
        userId,
        organisationId: organisation?.id,
        userTestId: userTest.id
      }}
      entitlementsQuery={PATIENT_ENTITLEMENTS_QUERY}
      entitlementsQueryVariables={{
        userId,
        organisationId: organisation?.id
      }}
      skip={!organisation || !userId}
      description={DESCRIPTION}
      getReportCardState={getReportCardState}
      onReportClick={report => {
        history.push(
          getCmpUrl(CMP_PATIENTS_REPORT_TAB_URL, {
            organisationId: organisation?.hashId,
            patientId: userId,
            reportSlug: report.slug,
            tab: "overview"
          })
        );
      }}
    />
  );
}
